import { render } from "./VendorBill_View.vue?vue&type=template&id=97d85c82"
import script from "./VendorBill_View.vue?vue&type=script&lang=js"
export * from "./VendorBill_View.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__